import { Component } from '@angular/core';

@Component({
    selector: 'default-error-svg',
    templateUrl: './default-error-svg.component.svg',
    styleUrls: ['./default-error-svg.component.scss'],
})
export class DefaultErrorSvgComponent {}
